/**
 * Given a wheel event, returns the direction in which the wheel was scrolled
 * @param event - WheelEvent
 * @returns - direction string
 */
export const getWheelDirection = (
  event: WheelEvent
): 'up' | 'down' | 'left' | 'right' | null => {
  const {deltaX, deltaY} = event;

  if (Math.abs(deltaY) > Math.abs(deltaX)) {
    // Vertical scroll
    if (deltaY > 0) {
      return 'down';
    } else if (deltaY < 0) {
      return 'up';
    }
  } else {
    // Horizontal scroll
    if (deltaX > 0) {
      return 'right';
    } else if (deltaX < 0) {
      return 'left';
    }
  }

  return null;
};
